import { GlobalContext, Section } from "../lib/Root";
import { useContext, useEffect } from "react";

export default function AccountRecover() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "Recover"; }, []);

	return <Section center>
		<p>Should have remembered your password...</p>
	</Section>;
}